export default {
  vipUpgrade: {
    title: 'Parabéns!!',
    message: 'Você foi promovido de VIP{from} para VIP{to}',
    subtitle: 'Obrigado pelo seu apoio. Seu novo nível traz\nserviços exclusivos e privilégios especiais.',
    ok: 'OK'
  },
  settle: {
    loading: "Settling...",
    cannotEnterGame: "Your balance is being settled, please try again later.",
    blockedTitle: "Settling In Progress",
    blockedMsg: "Your balance is still being settled. Please wait a moment and try again."
  }
};
